import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import bankAccountContactsServices from './BankAccountContacts.services';

const QUERY_KEY = 'bankAccountContacts';

export function useBankAccountContactList(bankAccountId: number) {
  return useQuery(
    [QUERY_KEY, bankAccountId],
    () => bankAccountContactsServices.list(bankAccountId),
    {
      enabled: !!bankAccountId,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useBankAccountContactCreate() {
  const queryClient = useQueryClient();

  return useMutation(bankAccountContactsServices.create, {
    onSuccess(_, data) {
      notification.success({
        message: 'Contato cadastrado com sucesso!',
      });
      queryClient.invalidateQueries([QUERY_KEY, data.bankAccountId]);
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useBankAccountContactEdit() {
  const queryClient = useQueryClient();

  return useMutation(bankAccountContactsServices.edit, {
    onSuccess(_, data) {
      notification.success({
        message: 'Contato editado com sucesso!',
      });
      queryClient.invalidateQueries([QUERY_KEY, data.bankAccountId]);
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useBankAccountContactRemove() {
  const queryClient = useQueryClient();

  return useMutation(bankAccountContactsServices.remove, {
    onSuccess(_, data) {
      notification.success({
        message: 'Contato removido com sucesso!',
      });
      queryClient.invalidateQueries([QUERY_KEY, data.bankAccountId]);
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useBankAccountContactRemoveDetail() {
  const queryClient = useQueryClient();

  return useMutation(bankAccountContactsServices.removeDetail, {
    onSuccess(_, data) {
      notification.success({
        message: 'Detalhe do contato removido com sucesso!',
      });
      queryClient.invalidateQueries([QUERY_KEY, data.bankAccountId]);
    },
    onError(error) {
      notificationError(error);
    },
  });
}
